import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { B as I } from "./button-CUHBhgeQ.mjs";
import { f as c } from "./index-LyFokDcn.mjs";
import { T as h } from "./text-button-yPCa43NP.mjs";
import o, { forwardRef as _, cloneElement as k } from "react";
import { T as M } from "./tooltip-Cy1xtUCm.mjs";
import { l as f } from "./lodash-5ofSKtz3.mjs";
import { m as b } from "./tss-DN0acMKN.mjs";
import { M as B, d as H } from "./constants-CnFYFetN.mjs";
import { I as T } from "./icon-button-BxDvkq_l.mjs";
const g = (e) => o.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 12", width: "16", height: "12" }, e),
  o.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    o.createElement(
      "g",
      { fillRule: "nonzero" },
      o.createElement("path", { d: "M888,599.53675 C887.523333,599.53675 887.046667,599.4373 886.603333,599.23775 L880,596.26595 L880,602.7 C880,603.41825 880.596667,604 881.333333,604 L894.666667,604 C895.403333,604 896,603.41825 896,602.7 L896,596.2653 L889.396667,599.2371 C888.953333,599.4373 888.476667,599.53675 888,599.53675 Z M894.666667,592 L881.333333,592 C880.596667,592 880,592.58175 880,593.3 L880,594.834 L887.162,598.0567 C887.694667,598.2959 888.306,598.29655 888.838667,598.0567 L896,594.834 L896,593.3 C896,592.58175 895.403333,592 894.666667,592 Z", transform: "translate(-880 -592)" })
    )
  )
);
g.displayName = "Envelope16x12";
const C = (e) => o.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 9 12", width: "9", height: "12" }, e),
  o.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    o.createElement(
      "g",
      { fillRule: "nonzero" },
      o.createElement("path", { d: "M340.5005,134 C337.5,134 336,136.25 336,138.5 C336,140.75 340.5005,146 340.5005,146 C340.5005,146 345,140.75 345,138.5 C345,136.25 343.5,134 340.5005,134 Z M340.5,140 C339.6715,140 339,139.3285 339,138.5 C339,137.6715 339.6715,137 340.5,137 C341.3285,137 342,137.6715 342,138.5 C342,139.3285 341.3285,140 340.5,140 Z", transform: "translate(-336 -134)" })
    )
  )
);
C.displayName = "Location9x12";
const v = (e) => o.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 16", width: "18", height: "16" }, e),
  o.createElement(
    o.Fragment,
    null,
    o.createElement(
      "g",
      { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
      o.createElement(
        "g",
        null,
        o.createElement(
          "g",
          null,
          o.createElement("path", { fillRule: "nonzero", d: "M7.00534948,10.7443172 L5.22316667,12.5265 L8.8817842e-16,14 L1.4735,8.77683333 L7.32725,2.92308333 L10.1324607,5.72829403 C8.33652501,6.70726157 7.0962015,8.5772224 7.00534948,10.7443172 Z M12.7443172,5.00534948 C12.2450936,5.02627864 11.7616384,5.10820818 11.3012115,5.24387814 L8.15383333,2.0965 L9.47333333,0.777 C9.97383333,0.275916667 10.64,8.8817842e-16 11.3481667,8.8817842e-16 C12.0563333,8.8817842e-16 12.7225,0.275916667 13.223,0.777 C13.7240833,1.2775 14,1.94308333 14,2.65183333 C14,3.36 13.7240833,4.02616667 13.223,4.52666667 L12.7443172,5.00534948 Z", transform: "translate(-204 -29) translate(204 29)" }),
          o.createElement("path", { d: "M13,16 C10.2385763,16 8,13.7614237 8,11 C8,8.23857625 10.2385763,6 13,6 C15.7614237,6 18,8.23857625 18,11 C18,13.7614237 15.7614237,16 13,16 Z M15.666015,8.13446895 C15.3202735,7.88904257 14.8552849,7.98944427 14.6257905,8.35519332 L12.4703435,11.7903658 L11.1661255,10.8660327 C10.821134,10.6206063 10.3561454,10.721008 10.1259011,11.086757 C9.89640675,11.4525061 9.98940446,11.9481399 10.333646,12.1919726 L12.8858333,14 L15.8730099,9.23888765 C16.1040042,8.8731386 16.0110065,8.37830165 15.666015,8.13446895 Z", transform: "translate(-204 -29) translate(204 29)" })
        )
      )
    )
  )
);
v.displayName = "PencilCheck18x16";
const O = b()(({ constructs: e, spacing: t, mode: n }, { hasIcon: l, iconPlacement: i }, a) => ({
  root: {
    display: "inline-grid",
    gridTemplateColumns: "1fr auto",
    gridTemplateRows: "1fr",
    outline: n === B.Dye ? `1px solid ${H.main}` : void 0,
    [`&:hover .${a.iconRightInside}, &:hover .${a.iconRightOutside}, &:hover .${a.iconLeftInside}, &:hover .${a.iconLeftOutside}`]: {
      opacity: 1,
      fill: e.text.neutral.weak
    },
    [`&:hover .${a.children}`]: {
      opacity: 1
    }
  },
  component: {
    gridRow: "1"
  },
  children: {
    alignSelf: "center",
    gridRow: "1",
    marginLeft: (i == null ? void 0 : i.search("left-outside")) === -1 || l ? t(1) : void 0,
    marginRight: (i == null ? void 0 : i.search("left-outside")) !== -1 && !l ? t(1) : void 0,
    opacity: 0,
    "&:focus-within": {
      opacity: 1
    }
  },
  componentLeftInside: {
    gridColumn: "1 / 3"
  },
  componentLeftOutside: {
    gridColumn: "2 / 3"
  },
  componentRightInside: {
    gridColumn: "1 / 3"
  },
  componentRightOutside: {
    gridColumn: "1 / 2"
  },
  icon: {
    alignSelf: "center",
    gridRow: "1",
    opacity: 0,
    "&:focus": {
      opacity: 1
    }
  },
  iconLeftInside: {
    "&&&": {
      gridColumn: "1 / 2",
      paddingLeft: t(1.5)
    }
  },
  iconLeftOutside: {
    "&&&": {
      gridColumn: "1 / 2",
      paddingRight: t(1.5)
    }
  },
  iconRightInside: {
    "&&&": {
      gridColumn: "2 / 3",
      paddingRight: t(1.5)
    }
  },
  iconRightOutside: {
    "&&&": {
      gridColumn: "2 / 3",
      paddingLeft: t(1.5)
    }
  }
})), d = _(
  ({
    children: e,
    classes: t = {},
    component: n,
    hasIcon: l,
    iconLink: i,
    iconPlacement: a = "right-inside",
    onClick: L,
    IconButtonProps: x,
    tooltipTitle: w,
    tooltipContent: R,
    TooltipProps: j
  }, E) => {
    const y = k(n, { disabled: !0, isDisabled: !0 }), m = f.capitalize(a.split("-")[0]), p = f.capitalize(a.split("-")[1]), { classes: s, cx: u } = O({ hasIcon: l, iconPlacement: a }, { props: { classes: t } });
    return /* @__PURE__ */ r.jsxs("div", { className: s.root, "data-fabric-component": "HoverWrapper", ref: E, children: [
      /* @__PURE__ */ r.jsx("div", { className: u(s.component, s[`component${m}${p}`]), children: y }),
      l && /* @__PURE__ */ r.jsx(M, { content: R, title: w, ...j, children: /* @__PURE__ */ r.jsx(
        T,
        {
          "aria-label": window.jQuery ? $.__("Show Tooltip") : "Show Tooltip",
          className: u(s.icon, s[`icon${m}${p}`]),
          floatingIcon: !0,
          href: i,
          icon: c.ifFeature("encore", "memo-circle-check-solid", /* @__PURE__ */ r.jsx(v, {})),
          noBoundingBox: !0,
          onClick: L,
          ...x
        }
      ) }),
      e && /* @__PURE__ */ r.jsx("div", { className: s.children, children: e })
    ] });
  }
);
d.defaultProps = {
  hasIcon: !0,
  tooltipTitle: window.jQuery ? $.__("Pending Approval") : "Pending Approval",
  tooltipContent: window.jQuery ? $.__("The latest change to this field is waiting for approval. Click to go to the original request.") : "The latest change to this field is waiting for approval. Click to go to the original request."
};
const D = (e) => {
  const {
    children: t,
    hover: { className: n, handleHoverAction: l, text: i }
  } = e;
  return /* @__PURE__ */ r.jsx(d, { component: t, hasIcon: !1, children: /* @__PURE__ */ r.jsx(I, { className: n, onClick: l, type: "button", children: i }) });
}, V = (e) => {
  const { children: t, value: n } = e;
  return /* @__PURE__ */ r.jsx(d, { component: t, hasIcon: !1, children: /* @__PURE__ */ r.jsx(h, { href: `mailto:${n}`, startIcon: c.ifFeature("encore", "envelope-solid", /* @__PURE__ */ r.jsx(g, {})), children: window.jQuery ? $.__("Email") : "Email" }) });
}, J = (e) => {
  const { children: t, hover: n } = e;
  return /* @__PURE__ */ r.jsx(d, { component: t, hasIcon: !1, children: /* @__PURE__ */ r.jsx(h, { href: n.link, children: window.jQuery ? $.__("View") : "View" }) });
}, K = (e) => {
  const { children: t, hover: n } = e;
  return /* @__PURE__ */ r.jsx(d, { component: t, hasIcon: !1, children: /* @__PURE__ */ r.jsx(h, { href: n.link, startIcon: c.ifFeature("encore", "location-dot-solid", /* @__PURE__ */ r.jsx(C, {})), children: window.jQuery ? $.__("Map") : "Map" }) });
};
export {
  d as H,
  D as a,
  V as b,
  J as c,
  K as d
};
//# sourceMappingURL=hover-map-DhNrBpls.mjs.map
